<template>
  <div class="pt-15 animated fadeIn staticPageInner equipmentList bgV2">
    <div class="boxShadow setBorderRadius heig-frame-equipment-group">
      <b-row no-gutters>
        <b-col md="12" class="heig-frame-child">
          <gofix-card class="mb-0 heig-frame-child" fullContent>
            <gofix-default-table :settings="tableConfig"
                         :table-items="tableItems"
                         @load-items="getTableData"
                         @new-item="openCreateModal"
                         @row-click="openEditModal"
                         @delete-items="deleteItems"
                         @export="exportNLT"
                         ref="gofixTable">
            </gofix-default-table>
          </gofix-card>
        </b-col>
      </b-row>
    </div>
    <b-modal size="lg" :no-close-on-backdrop="true" id="modal-Create" :title="modals.create.title" hide-footer :centered="true" v-model="modals.create.open" @show="showModal">
      <b-form class="">
        <b-row>
          <b-col md="12">
            <gofix-form-tree
                label="Service Category"
                :default-expand-level="1"
                :multiple="false"
                :options="modals.create.dataService"
                :load-options="loadOptionsService"
                :normalizer="normalizerService"
                search-nested
                valueFormat="object"
                v-model="modals.create.data.service_category"
                placeholder="Select"
                ref="input">
            </gofix-form-tree>
          </b-col>
          <b-col md="12">
            <gofix-form-input label="Centre office" v-model="modals.create.data.centre_office"></gofix-form-input>
          </b-col>
          <b-col md="12">
            <gofix-form-input label="Requestor type" v-model="modals.create.data.requestor_type"></gofix-form-input>
          </b-col>
          <b-col md="12">
            <gofix-form-input label="Requestor company" v-model="modals.create.data.requestor_company"></gofix-form-input>
          </b-col>
          <!-- <b-col md="12"> -->
            <!--  v-model="modals.create.data.to_team_id" -->
            <!-- <gofix-form-dropdown
                label="To Team"
                vLabel="group_name"
                :reduce="option => option.id"
                :filterable="false"
                :clearable="true"
                @search="searchToTeam"
                v-model="modals.create.data.to_team_id"
                :options="toteam">
            </gofix-form-dropdown> -->
          <!-- </b-col> -->
          <!-- <b-col md="12">
            <gofix-form-dropdown
                label="CC Team"
                vLabel="group_name"
                :reduce="option => option.id"
                :filterable="false"
                :clearable="true"
                @search="searchCcTeam"
                v-model="modals.create.data.cc_team_id"
                :options="ccteam">
            </gofix-form-dropdown>
          </b-col> -->

          <!-- 4199 [NLT] Alternative solution for escalation without creating FM teams and FM user -->
          <b-col md="12" class="mb-26">
            <div class="nltTableUser gofixTables">
              <gofix-text-field class="mb-2 pl-3 py-2" label="To Team" oneline>{{ modals.create.data.to_team_name }}</gofix-text-field>
              <div class="nltTable">
                <b-table striped hover fixed :items="modals.create.table.toTeamUsers.items" :fields="modals.create.table.fields" 
                  @sort-changed="(ctx) => {
                    sortingChanged(ctx, 'toTeamUsers')
                  }">
                  <template :slot="'HEAD_display_name'" slot-scope="data">
                    {{data.label}}
                    <span class="icon-sorting">
                      <i class="fa fa-caret-up icons font-xs" v-bind:class="{active : modals.create.table.toTeamUsers.sortColumn === data.column && modals.create.table.toTeamUsers.sortDirection}"></i>
                      <i class="fa fa-caret-down down icons font-xs" v-bind:class="{active : modals.create.table.toTeamUsers.sortColumn === data.column && !modals.create.table.toTeamUsers.sortDirection}"></i>
                    </span>
                  </template>
                  <template :slot="'HEAD_email'" slot-scope="data">
                    {{data.label}}
                    <span class="icon-sorting">
                      <i class="fa fa-caret-up icons font-xs" v-bind:class="{active : modals.create.table.toTeamUsers.sortColumn === data.column && modals.create.table.toTeamUsers.sortDirection}"></i>
                      <i class="fa fa-caret-down down icons font-xs" v-bind:class="{active : modals.create.table.toTeamUsers.sortColumn === data.column && !modals.create.table.toTeamUsers.sortDirection}"></i>
                    </span>
                  </template>
                  <template slot="actions" slot-scope="data">
                    <span @click="removeUserToTeam('toTeamUsers', data.item.id)">
                      <img src="img/deleteIcon.png" width="16px" alt="Delete">
                    </span>
                  </template>
                </b-table>
              </div>
              <div class="d-flex align-items-center">
                <gofix-form-dropdown
                  label=" "
                  class="mb-0 pr-2"
                  vLabel="email"
                  :filterable="false"
                  :clearable="true"
                  @search="searchAddressBook"
                  v-model="modals.create.tmp.userToTeam"
                  :options="modals.create.addressBooks">
                  <template slot="gofixInput:dropdown:selected-option" slot-scope="option">
                    {{ `${option.email} - ${option.display_name}` }}
                  </template>
                  <template slot="gofixInput:dropdown:option" slot-scope="option">
                    {{ `${option.email} - ${option.display_name}` }}
                  </template>
                </gofix-form-dropdown>
                <span class="cursor-pointer" @click="addUserToTeam('userToTeam', 'toTeamUsers')">
                  <svg width="21" height="21" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 304.223 304.223" xml:space="preserve">
                    <path fill="#999999" d="M152.112,0C68.241,0,0.008,68.244,0.008,152.114c0,83.865,68.233,152.109,152.103,152.109 c83.865,0,152.103-68.244,152.103-152.109C304.215,68.244,235.977,0,152.112,0z M152.112,275.989c-68.32,0-123.891-55.565-123.891-123.875c0-68.326,55.571-123.891,123.891-123.891s123.891,55.565,123.891,123.891C276.003,220.424,220.426,275.989,152.112,275.989z"/>
                    <path fill="#999999" d="M221.922,139.186h-56.887V82.298c0-7.141-5.782-12.929-12.923-12.929c-7.141,0-12.929,5.782-12.929,12.929v56.887H82.296c-7.141,0-12.923,5.782-12.923,12.929c0,7.141,5.782,12.923,12.923,12.923h56.882v56.893c0,7.142,5.787,12.923,12.929,12.923c7.141,0,12.929-5.782,12.929-12.923v-56.893h56.882c7.142,0,12.929-5.782,12.929-12.923C234.851,144.967,229.063,139.186,221.922,139.186z"/>
                  </svg>
                </span>
              </div>
            </div>
          </b-col>
          <b-col md="12" class="mb-26">
            <div class="nltTableUser gofixTables">
              <gofix-text-field class="mb-2 pl-3 py-2" label="CC Team" oneline>{{ modals.create.data.cc_team_name }}</gofix-text-field>
              <div class="nltTable">
                <b-table striped hover fixed :items="modals.create.table.ccTeamUsers.items" :fields="modals.create.table.fields" 
                  @sort-changed="(ctx) => {
                    sortingChanged(ctx, 'ccTeamUsers')
                  }">
                  <template :slot="'HEAD_display_name'" slot-scope="data">
                    {{data.label}}
                    <span class="icon-sorting">
                      <i class="fa fa-caret-up icons font-xs" v-bind:class="{active : modals.create.table.ccTeamUsers.sortColumn === data.column && modals.create.table.ccTeamUsers.sortDirection}"></i>
                      <i class="fa fa-caret-down down icons font-xs" v-bind:class="{active : modals.create.table.ccTeamUsers.sortColumn === data.column && !modals.create.table.ccTeamUsers.sortDirection}"></i>
                    </span>
                  </template>
                  <template :slot="'HEAD_email'" slot-scope="data">
                    {{data.label}}
                    <span class="icon-sorting">
                      <i class="fa fa-caret-up icons font-xs" v-bind:class="{active : modals.create.table.ccTeamUsers.sortColumn === data.column && modals.create.table.ccTeamUsers.sortDirection}"></i>
                      <i class="fa fa-caret-down down icons font-xs" v-bind:class="{active : modals.create.table.ccTeamUsers.sortColumn === data.column && !modals.create.table.ccTeamUsers.sortDirection}"></i>
                    </span>
                  </template>
                  <template slot="actions" slot-scope="data">
                    <span @click="removeUserToTeam('ccTeamUsers', data.item.id)">
                      <img src="img/deleteIcon.png" width="16px" alt="Delete">
                    </span>
                  </template>
                </b-table>
                
              </div>
              <div class="d-flex align-items-center">
                <gofix-form-dropdown
                  label=" "
                  class="mb-0 pr-2"
                  vLabel="email"
                  :filterable="false"
                  :clearable="true"
                  @search="searchAddressBook"
                  v-model="modals.create.tmp.userCcTeam"
                  :options="modals.create.addressBooks">
                  <template slot="gofixInput:dropdown:selected-option" slot-scope="option">
                    {{ `${option.email} - ${option.display_name}` }}
                  </template>
                  <template slot="gofixInput:dropdown:option" slot-scope="option">
                    {{ `${option.email} - ${option.display_name}` }}
                  </template>
                </gofix-form-dropdown>
                <span class="cursor-pointer" @click="addUserToTeam('userCcTeam', 'ccTeamUsers')">
                  <svg width="21" height="21" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 304.223 304.223" xml:space="preserve">
                    <path fill="#999999" d="M152.112,0C68.241,0,0.008,68.244,0.008,152.114c0,83.865,68.233,152.109,152.103,152.109 c83.865,0,152.103-68.244,152.103-152.109C304.215,68.244,235.977,0,152.112,0z M152.112,275.989c-68.32,0-123.891-55.565-123.891-123.875c0-68.326,55.571-123.891,123.891-123.891s123.891,55.565,123.891,123.891C276.003,220.424,220.426,275.989,152.112,275.989z"/>
                    <path fill="#999999" d="M221.922,139.186h-56.887V82.298c0-7.141-5.782-12.929-12.923-12.929c-7.141,0-12.929,5.782-12.929,12.929v56.887H82.296c-7.141,0-12.923,5.782-12.923,12.929c0,7.141,5.782,12.923,12.923,12.923h56.882v56.893c0,7.142,5.787,12.923,12.929,12.923c7.141,0,12.929-5.782,12.929-12.923v-56.893h56.882c7.142,0,12.929-5.782,12.929-12.923C234.851,144.967,229.063,139.186,221.922,139.186z"/>
                  </svg>
                </span>
              </div>
            </div>
          </b-col>
          <!-- End -->


          <b-col md="12">
            <gofix-form-dropdown
                label="Notification Template"
                vLabel="title"
                :reduce="option => option.id"
                :append-to-body="true"
                :clearable="false"
                v-model="modals.create.data.notification_template_id"
                :options="modals.create.notifications">
            </gofix-form-dropdown>
          </b-col>
        </b-row>
      </b-form>
      <b-button-group class="d-block text-right" >
        <gofix-button label="SUBMIT" :loading="modals.create.loading" noBorder @click="save"></gofix-button>
      </b-button-group>
    </b-modal>
  </div>
</template>
<script>
import { filters } from '@/_filterVar.js'
import { mapGetters } from 'vuex';
import moment from "moment";
import {LOAD_CHILDREN_OPTIONS} from "@riophae/vue-treeselect";
const simulateAsyncOperation = fn => {
  setTimeout(fn, 500)
}


export default {
  name: 'nlt-escalation',
  data() {
    let filter =  JSON.parse(JSON.stringify(filters['escalation']));
    return {
      tableConfig:{
        name: 'nlt-escalation',
        controls:{},
        filter: filter,
        page: 1,
        limit: 100,
        total: 0,
        useDatabaseView: false,
        sortColumn: "id",
        sortDirection: "desc",
      },
      tableItems:[],
      modals:{
        create:{
          title: 'Create new',
          loading: false,
          open: false,
          data: {
            id: null,
            contract_id: null,
            service_category_id:null,
            service_category:null,
            centre_office:null,
            requestor_type:null,
            requestor_company:null,
            // to_team_id:null,
            // cc_team_id:null,
            notification_template_id:null,
            to_team: null,
            to_team_name: null,
            cc_team: null,
            cc_team_name: null,
          },
          dataService:[],
          userGroups:[],
          notifications:[],
          addressBooks: [],
          tmp: {
            userToTeam: null,
            userCcTeam: null,
          },
          table: {
            toTeamUsers: {
              items: [],
              sortColumn: null,
              sortDirection: null
            },
            ccTeamUsers: {
              items: [],
              sortColumn: null,
              sortDirection: null
            },
            fields: [
              {
                key: 'display_name',
                label: "Name",
                sortable: true,
                thStyle: 'width: 200px'
              },
              {
                key: 'email',
                label: "Email",
                sortable: true,
                thStyle: 'width: 200px'
              },
              { 
                key: 'actions',
                label: "",
                thStyle: 'width: 50px',
                thClass: 'text-center',
                tdClass: 'text-center'
              }
            ],
          }
        }
      },
      toteam:null,
      ccteam:null,
      timer: null
    }
  },
  watch: {
    ClientContractID: function(val, old){
      if(!old || (val && (old.id != val.id))) {
        this.getDataService(0, val.id, 'all',true);
        this.getUserGroup()
        this.getNotificationTemplate()
      }
    },
  },
  computed: {
    ...mapGetters({
      ClientContractID: 'ContractController/ClientContractID',
    })
  },
  created () {
    if (this.ClientContractID && this.ClientContractID.id){
      this.getDataService(0, this.ClientContractID.id, 'all',true);
      this.getUserGroup()
      this.getNotificationTemplate()
    }
  },

  methods: {
    async getTableData(callback){
      const { tableRequest , resolve,reject } = await callback();
      if(!this.ClientContractID || !this.ClientContractID.id){
        resolve({items:[],total:0})
        return;
      }
      await this.$store.dispatch("EscalationController/getItems", tableRequest)
          .then(response => {
            this.tableItems = response.items;
            this.tableConfig.total = response.total;
            resolve(response);
          })
          .catch(err => {
            this.$alertNotification("Can not load the data", "danger");
            reject();
          })
    },
    save(){
      if(!this.modals.create.data.service_category){
        return this.$alertNotification("Please select a service category", "danger");
      }
      let request = JSON.parse(JSON.stringify(this.modals.create.data))
      request.service_category_id = request.service_category.id
      request.to_address_book_ids = []
      request.cc_address_book_ids = []
      if(this.modals.create.table.toTeamUsers.items.length) {
        request.to_address_book_ids = this.modals.create.table.toTeamUsers.items.map(x => x.id);
      }
      if(this.modals.create.table.ccTeamUsers.items.length) {
        request.cc_address_book_ids = this.modals.create.table.ccTeamUsers.items.map(x => x.id);
      }
      if(!this.modals.create.data.id){
        this.$store.dispatch("EscalationController/saveItem", request)
            .then(response => {
              this.$refs.gofixTable.reloadTableItems();
              this.modals.create.loading = false;
              this.modals.create.open = false;
              this.$alertNotification(this.$notificationV2('adding', 'escalation'));
            })
            .catch(err => {
              this.modals.create.loading = false;
              this.modals.create.open = false;
              if( err.response.data.error && err.response.data.error.message.error) {
                return this.$alertNotification(err.response.data.error.message.error, "danger");
              }
              return this.$alertNotification(this.$notificationV2('existing', 'escalation'), "danger");
            });
      }else{
        this.$store.dispatch("EscalationController/updateItem", request)
            .then(response => {
              this.$refs.gofixTable.reloadTableItems();
              this.modals.create.loading = false;
              this.modals.create.open = false;
              this.$alertNotification(this.$notificationV2('editing', 'escalation'));
            })
            .catch(err => {
              this.modals.create.loading = false;
              this.modals.create.open = false;
              if( err.response.data.error && err.response.data.error.message.error) {
                return this.$alertNotification(err.response.data.error.message.error, "danger");
              }
              return this.$alertNotification(this.$notificationV2('existing', 'escalation'), "danger");
            });
      }
    },

    async deleteItems(callback){
      const { ids,filter, resolve,reject } = await callback();
      await this.$store.dispatch('EscalationController/deleteItems', ids)
          .then(response => {
            resolve(this.$notificationV2('deleting', 'escalation'));
          })
          .catch(err => {
            reject();
          })
    },
    searchToTeam(search, loading){
      console.log(search);
      this.toteam=this.modals.create.userGroups.filter(element => element.group_name.includes(search));

    },
    searchCcTeam(search, loading)
    {
      this.ccteam=this.modals.create.userGroups.filter(element => element.group_name.includes(search));
    },


    openCreateModal(){
      if(!this.ClientContractID || !this.ClientContractID.id){
        this.$alertNotification("Please select a contract", "danger");
        return
      }
      this.modals.create.title = 'Create new'
      this.modals.create.open = true
      this.modals.create.data = {
        id: null,
        contract_id: this.ClientContractID.id,
        service_category_id:null,
        service_category:null,
        centre_office:null,
        requestor_type:null,
        requestor_company:null,
        to_team_id:null,
        cc_team_id:null,
        notification_template_id:null,
      };
      this.modals.create.table.toTeamUsers.items = []
      this.modals.create.table.ccTeamUsers.items = []
    },
    openEditModal(item){
      this.modals.create.title = 'Edit'
      this.modals.create.open = true
      this.modals.create.data = {

        id: item.id,
        contract_id: this.ClientContractID.id,
        service_category_id:item.service_category_id,
        service_category:item.service_category,
        centre_office:item.centre_office,
        requestor_type:item.requestor_type,
        requestor_company:item.requestor_company,
        to_team_id:item.to_team_id,
        cc_team_id:item.cc_team_id,
        notification_template_id:item.notification_template_id,
        to_team: item.to_team,
        to_team_name: item.to_team_name,
        cc_team: item.cc_team,
        cc_team_name: item.cc_team_name,
      };
      this.modals.create.table.toTeamUsers.items = item.to_team && item.to_team.address_book ? item.to_team.address_book : []
      this.modals.create.table.ccTeamUsers.items = item.cc_team && item.cc_team.address_book ? item.cc_team.address_book : []
    },

    /*Load service category*/
    loadOptionsService({ action, parentNode, callback,instanceId  }){
      if (action === LOAD_CHILDREN_OPTIONS ) {
        simulateAsyncOperation(async () => {
          parentNode.children = await this.getDataService(parentNode.data.id,this.ClientContractID.id,'all');
          callback()
        })
      }
    },
    normalizerService(node) {
      if(node.data && !node.data.isBatch){
        return {
          children : undefined,
          label: node.name
        }
      }
      return {
        label: node.name
      }
    },
    async getDataService(parent_id,contract_id,node_type,set = false){
      let data = [];
      await  this.$store.dispatch("v2SorController/getService",{
        contract_id: this.ClientContractID.id,
        service_id: parent_id
      })
          .then( response => {
            data = response;
          })
          .catch( err => {
            data = [];
          });

      if(set) {
        this.modals.create.dataService = data;
      } else {
        return data
      }
    },

    /*Load team*/
    getUserGroup(){
      this.$store.dispatch("UserGroupController/getItems", {
        page: 1,
        limit: -1,
        filter: {
          contract_id: this.ClientContractID.id
        }
      })
          .then(response => {
            this.modals.create.userGroups = response.items;
            this.toteam=response.items;
            this.ccteam=response.items;
          })
          .catch(err => {
            this.modals.create.userGroups = [];
          })
    },

    /*Load notification templates*/
    getNotificationTemplate(){
      this.$store.dispatch("NotificationTemplateController/getItems", {
        page: 1,
        limit: -1,
        filter: {
          contract_id: this.ClientContractID.id
        },
        sortColumn: 'title',
        $sortDirection: 'asc',
      })
          .then(response => {
            this.modals.create.notifications = response.data.data.items;
          })
          .catch(err => {
            this.modals.create.notifications = [];
          })
    },

    /*-- Address Book --------*/
    showModal() {
      this.getListAddressBook()
    },
    sortingChanged(ctx, name) {
      this.modals.create.table[name].sortColumn = ctx.sortBy
      this.modals.create.table[name].sortDirection = ctx.sortDesc
    },
    addUserToTeam(name, table_name) {
      if(!this.modals.create.tmp[name]) return this.$alertNotification("Please select a item", "danger")
      // Check exist address book
      let arrTmp = this.modals.create.table.toTeamUsers.items.concat(this.modals.create.table.ccTeamUsers.items)
      let filters = arrTmp.filter(item => item.id == this.modals.create.tmp[name].id)
      if(filters.length) return this.$alertNotification("Email already exists in the list", "danger")
      this.modals.create.table[table_name].items.push(this.modals.create.tmp[name])
      this.modals.create.tmp[name] = null
    },
    removeUserToTeam(table_name, id) {
      this.modals.create.table[table_name].items = this.modals.create.table[table_name].items.filter(item => item.id != id)
    },
    async getListAddressBook(search) {
      let filters = {
        search: search,
        contract_id: this.modals.create.data.contract_id
      }
      await this.$store.dispatch('NLTAddressBookController/getItems', {
        page: 1,
        limit: 100,
        filter: filters
      })
      .then(response => {  
        this.modals.create.addressBooks = response.items;
      }).catch(error => {
        console.log(error);
      })
    },
    searchAddressBook(search, loading){
      this.modals.create.addressBooks = []
      loading(true);
      if(this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
      this.timer = setTimeout(async () => {
        try {
          await this.getListAddressBook(search);
          await loading(false);
        } catch (err) {
          loading(false);
        }
      }, 500);
    },
    exportNLT() {
        this.$refs.gofixTable.actionStatus.listLoading = true;
        this.$store.dispatch('EscalationController/exportExcel', {
        })
        .then(response => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'Escalation_Matrix_GOfix_'+moment().format('DDMMYYYY')+'.xlsx'); 
            document.body.appendChild(link);
            link.click();
            this.$refs.gofixTable.actionStatus.listLoading = false;
        }).catch(err => {
            this.$refs.gofixTable.actionStatus.listLoading = false;
        })
    },
  }
}
</script>
